import { css } from '@emotion/react'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import { memo } from 'react'
import { palette } from '../styles/colors'
import { PAPER_HEIGHTS } from '../theme'
import IconButton from './IconButton'

const buttonStyles = css({
    position: 'absolute',
    bottom: 0,
    left: `calc(env(safe-area-inset-left, 0px) * 0.7)`,
    color: '#fff',
    zIndex: PAPER_HEIGHTS.drawer,
    transition: 'none',
    filter: palette.overlayFilterDropShadow,
})

interface ButtonChatShowProps {
    onClick(event?: any): void
}

const ButtonChatShow = memo(({ onClick }: ButtonChatShowProps) => (
    <IconButton title="Show Chat" onClick={onClick} css={buttonStyles}>
        <ChatBubbleOutlineIcon
            fontSize="large"
            data-testid="ChatBubbleOutlineIcon"
        />
    </IconButton>
))

export default ButtonChatShow
